<template>
  <div style="background: white; border-radius: 5px;" v-loading="loading">
    <HeaderManageExamSchedule :centers="centers" @getListExamSchedule="getManageExamScheduleList"/>
    <hr style="padding: 0; margin: 0"/>
    <div style="padding:15px 20px">
      <div
          style="display: flex; flex-direction: column; gap: 15px; padding: 10px 0">
        <div class="grid-filter">
          <div class="display-flex-column">
            <span>Trung tâm</span>
            <el-select v-model="query.center_id" filterable clearable placeholder="Chọn trung tâm"
                       @change="handleSearch" collapse-tags>
              <el-option
                  v-for="item in centers"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="display-flex-column">
            <span>Loại ca thi</span>
            <el-select v-model="query.typeExam" filterable clearable placeholder="Chọn loại ca thi" @change="handleSearch">
              <el-option
                  v-for="item in examScheduleTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="display-flex-column">
            <span>Ngày thi</span>
            <el-date-picker
                style="width: 100%"
                v-model="query.examDate"
                type="date"
                align="right"
                placeholder="Chọn ngày thi"
                format="dd-MM-yyyy"
                value-format="yyyy-MM-dd"
                :default-value="new Date()"
                @change="handleSearch"
                clearable
            >
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="example-preview mt-8" style="height: 515px; overflow: auto">
        <table class="table table-vertical-center table-bordered" style="min-height: 100px">
          <thead style="position:sticky; top: 0">
            <tr style="background-color: #F8F8F8;">
              <th scope="col" class="w-[40px]" style="background: #F8F8F8; text-align: start">Thời gian thi</th>
              <th scope="col" class="min-w-[80px]" style="background: #F8F8F8;white-space: nowrap; text-align: start">Ngày thi</th>
              <th scope="col" class="min-w-[80px]" style="background: #F8F8F8;white-space: nowrap; text-align: start">Trung tâm</th>
              <th scope="col" class="min-w-[80px]" style="background: #F8F8F8;white-space: nowrap; text-align: start">Giám thị coi</th>
              <th scope="col" class="min-w-[40px]" style="background: #F8F8F8; text-align: start;">Hình thức thi</th>
              <th scope="col" class="min-w-[80px]" style="background: #F8F8F8; text-align: start">Loại bài thi</th>
              <th scope="col" class="w-100px text-center" style="background: #F8F8F8">Hành động</th>
            </tr>
          </thead>
          <tbody v-if="manageExamScheduleList?.length > 0">
            <tr v-for="item of manageExamScheduleList" :key="item?.id" style="border: 1px solid #EBEDF3; border-top: 0">
              <td>{{ item?.timeExam }}</td>
              <td style="text-align: start">{{ item?.dateExam }}</td>
              <td style="text-align: start">{{ item?.center }}</td>
              <td style="text-align: start">{{ item?.adminName }}</td>
              <td style="text-align: start">{{ item?.testForm }}</td>
              <td style="text-align: start">{{ item?.type }}</td>
              <td class="text-center">
                <button :disabled="item?.action?.isDeletable === false" class="btn btn-icon btn-xs btn-outline-danger ml-2" @click="confirmDelete(item)" title="Xoá">
                  <i class="el-icon-delete"></i>
                </button>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr style="word-break: break-word; white-space: nowrap; position: relative; border: 1px solid #EBEDF3">
              <label style="position: absolute; left: 50%; translate: -50%; top: 10px">Không có dữ liệu</label>
            </tr>
          </tbody>
        </table>
        <div v-if="manageExamScheduleList?.length > 0">
          <div class="edu-paginate mx-auto text-center mt-10 mb-5"
               style="display: flex; justify-content: center; align-items: center; height: 50px">
            <paginate
                v-model="page"
                :page-count="lastPage"
                :page-range="3"
                :margin-pages="1"
                :click-handler="changePage"
                :prev-text="'Trước'"
                :next-text="'Sau'"
                :container-class="'pagination b-pagination'"
                :pageLinkClass="'page-link'"
                :next-link-class="'next-link-item'"
                :prev-link-class="'prev-link-item'"
                :prev-class="'page-link'"
                :next-class="'page-link'"
                :page-class="'page-item'"
            >
            </paginate>
          </div>
          <div class="w-100" style="display: flex;justify-content: flex-end; margin-top: -50px">
            <div>
              Tổng số bản ghi: <span
                style="color: #0066FF; font-weight: 600; margin-left: 5px;">{{
                this.total ?? manageExamScheduleList.length
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="Xoá lịch thi" :show-close="false" :visible.sync="isDelete"
               v-if="isDelete" width="30%">
      <hr style="padding: 0; margin-top: -20px"/>
      <p style="word-break: break-word">Bạn có chắc chắn muốn xóa lịch thi ngày {{ recordSelected?.dateExam }} không?</p>
      <div style="display: flex;justify-content: flex-end; gap: 5px; margin-top: 20px">
        <el-button class="button-cancel" @click="isDelete = false">Đóng</el-button>
        <el-button
            v-loading="loadingDelete"
            style="background: #5E00B6; color: white; padding-left: 15px; padding-right: 15px; border-radius: 4px"
            type="primary" @click="handleDelete"
            :disabled="loadingDelete">
          Xác nhận
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import HeaderManageExamSchedule from "./component/HeaderManageExamSchedule.vue";
import {ExamScheduleModel} from "./model/ExamScheduleModel";
import {DELETE_EXAM_SCHEDULE, GET_LIST_EXAM_SCHEDULE} from "@/core/services/store/examSchedule/examSchedule";
import {GET_CENTER_TAG_E} from "@/core/services/store/task-management/task-management.module";
import {examScheduleTypes} from "@/common/define";

export default {
  name: "ManageExamScheduleList",
  components: {HeaderManageExamSchedule},
  data() {
    return {
      isDelete: false,
      loading: false,
      page: 1,
      lastPage: 1,
      total: 0,
      manageExamScheduleList: [],
      centers: [],
      recordSelected: {},
      examScheduleTypes,
      loadingDelete: false,
      query: {
        center_id: null,
        typeExam: null,
        examDate: null,
      },
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Danh sách lịch thi", name: 'ManageExamScheduleList'},
      {title: "Coi thi - Chấm thi"}
    ]);
    this.getManageExamScheduleList()
    this.getCenterTagE()
  },
  methods: {
    changePage(obj) {
      this.page = obj;
      this.getManageExamScheduleList()
    },
    callApi() {
      this.loading = true
      const payload = {
        page: this.page,
        center_id: this.query.center_id,
        exam_type: this.query.typeExam,
        exam_date: this.query.examDate,
      }
      this.$store.dispatch(GET_LIST_EXAM_SCHEDULE, payload).then(res => {
        if (!res.error) {
          this.page = res.pagination.current_page
          this.lastPage = res.pagination.last_page
          this.total = res.pagination.total
          this.manageExamScheduleList = res.data.map(item => {
            return new ExamScheduleModel(item)
          }) ?? []
        }
      }).catch(e => {
        console.log(e, 'error')
      }).finally(() => {
        this.loading = false
      })
    },
    getCenterTagE() {
      const payload  = {
        limit: 10000,
        is_edutalk: 1,
        status: 1,
      }
      this.$store.dispatch(GET_CENTER_TAG_E, payload).then(res => {
        if (!res.error) {
          this.centers = res.data?.data
        }
      })
    },
    async handleSearch() {
      this.page = 1
      await this.pushParams()
      this.getManageExamScheduleList()
    },
    async pushParams() {
      await this.$router.push({
        name: 'ManageExamScheduleList',
        query: {
          center_id: this.query.center_id,
          typeExam: this.query.typeExam,
          examDate: this.query.examDate,
        }
      })
      return null
    },
    getManageExamScheduleList() {
      this.getParams()
      this.callApi()
    },
    getParams() {
      const query = this.$route.query
      this.query.center_id = query.center_id ? +query.center_id : null
      this.query.typeExam = query.typeExam !== undefined && query.typeExam !== null && query.typeExam !== '' ? +query.typeExam : null;
      this.query.examDate = query.examDate ?? null
    },
    confirmDelete(item) {
      this.isDelete = true
      this.recordSelected = item
    },
    handleDelete() {
      this.loadingDelete = true
      this.$store.dispatch(DELETE_EXAM_SCHEDULE, {id: this.recordSelected.id}).then(res => {
        if (!res.error) {
          this.$message.success("Xóa lịch thi thành công!")
          this.getManageExamScheduleList()
        }
      }).catch((e) => {
        this.$message.error(e.data.message || 'Xóa lịch thi thất bại!')
      }).finally(() => {
        this.loadingDelete = false
        this.isDelete = false
      })
    }
  },
}
</script>

<style scoped>
.display-flex-column {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.mx-datepicker-popup {
  z-index: 9999999 !important;
}

.grid-filter {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 10px 60px;
}

@media screen and (max-width: 1560px) {
  .grid-filter {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 10px 30px;
  }
}
</style>
